//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.MotionObject.js";
import "../no/Display.js";
let d=[[],[[[],"GetCamera",{R_:{animationCameraObject:"Display.AnimationCamera"}},0,0],[["animationCameraObject"],"SetCamera",{},1,0],[[],"RemoveCamera",{},0,0],[["tagObject"],"GetObjectBlankStatus",{R_:{blankStatus:''}},1,0],[["tagObject","blankStatus"],"SetObjectBlankStatus",{},2,0],[[],"CloneAnimation",{R_:{newAnimationObject:"Motion.Animation"}},0,0],[["animationVector"],"GetAnimationVectorBlankStatus",{R_:{blankStatus:''}},1,0],[["animationVector","blankStatus"],"SetAnimationVectorBlankStatus",{},2,0],[["viewIndex"],"AttachViewport",{},1,0],[[],"DetachViewport",{},0,0],[[],"GetViewport",{R_:{viewport:''}},0,0],[[],"RecoverAnimationView",{},0,0]],[]];
SPLM.Motion.Animation = class extends SPLM.Motion.MotionObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.Animation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;